import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.directive('alert', (el, { expression }, { evaluate }) => {
    const detail = evaluate(expression)
    const id = Math.random().toString(16).slice(2)
    el.setAttribute('id', id)

    el.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent('alert', {
            detail: {
                id: id,
                title: detail.title,
                type: detail.type,
                description: detail.description,
                cancelLabel: detail.cancelLabel,
                showCloseButton: detail.showCloseButton,
            }
        }));
    })
})
